import { Color, PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#FDFEFE',
  100: '#eeeeee',
  200: '#d5d5d5',
  300: '#c1c1c1',
  400: '#a0a0a0',
  500: '#7f7f7f',
  600: '#6b6b6b',
  700: '#2B2B2B',
  800: '#2B2B2B',
  900: '#2B2B2B',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary: PaletteColorOptions = {
  light: '#77D5BB',
  main: '#48C9B0',
  dark: '#2E968E',
  contrastText: '#FFFFFF',
};

const secondary: PaletteColorOptions = {
  light: '#566F7C',
  main: '#34495E',
  dark: '#21364B',
  contrastText: '#FFFFFF',
};

const info: PaletteColorOptions = {
  light: '#FF965A',
  main: '#FF7F50',
  dark: '#FF5A1E',
  contrastText: '#000000',
};

const serenePalette: PaletteOptions = {
  mode: 'light',
  action: {
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#2B2B2B',
    secondary: '#475569',
    disabled: '#a0a0a0',
  },
  background: { paper: '#FDFEFE', default: '#FFFFFF' },
};

export default serenePalette;
